import { payrollConstants } from "actions/types";
import { keyBy } from "lodash";
import type { PayrollState } from "types/state";

interface PayrollAction {
  type: string;
  data?: unknown;
}

const initialState: PayrollState = {
  pendingContributionChanges: {},
  usersWhoLeftPlan: {},
  contributionsWithNoChange: {},
  totalAmounts: {},
  paginatedPendingContributionChangesCount: 0,
  paginatedContributionsCount: 0,
  paginatedPendingContributionChanges: [],
};

export function payroll(
  state: PayrollState = initialState,
  action: PayrollAction
): PayrollState {
  switch (action.type) {
    case payrollConstants.GET_PAYROLL_LINE_ITEMS_SUCCESS: {
      const data = action.data as {
        pendingContributionChanges?: object[];
        usersWhoLeftPlan?: object[];
        contributionsWithNoChange?: object[];
      };
      return {
        ...state,
        pendingContributionChanges: keyBy(
          data.pendingContributionChanges,
          "id"
        ),
        usersWhoLeftPlan: keyBy(data.usersWhoLeftPlan, "id"),
        contributionsWithNoChange: keyBy(data.contributionsWithNoChange, "id"),
      };
    }
    case payrollConstants.GET_PAGINATED_CHANGE_REQUESTS_SUCCESS: {
      const data = action.data as { rows: unknown[]; count: number };
      return {
        ...state,
        paginatedPendingContributionChanges: data.rows,
        paginatedPendingContributionChangesCount: data.count,
      };
    }
    case payrollConstants.GET_PAGINATED_CONTRIBUTIONS_SUCCESS: {
      const data = action.data as { rows: unknown[]; count: number };
      return {
        ...state,
        paginatedContributions: data.rows,
        paginatedContributionsCount: data.count,
      };
    }
    case payrollConstants.GET_TOTAL_AMOUNT_SAVED_SUCCESS: {
      return {
        ...state,
        totalAmounts: {
          ...state.totalAmounts,
          totalAmount: (action.data as { totalAmount?: unknown }).totalAmount,
        },
      };
    }

    case payrollConstants.DISMISS_PAYROLL_SUCCESS: {
      return {
        ...state,
        dismissPayroll: action.data,
      };
    }

    default:
      return state;
  }
}
